import { useThemeProps as m } from "@mui/system";
import o from "./defaultTheme.mjs";
import t from "./identifier.mjs";
function f({
  props: e,
  name: r
}) {
  return m({
    props: e,
    name: r,
    defaultTheme: o,
    themeId: t
  });
}
export {
  f as default
};
//# sourceMappingURL=useThemeProps.mjs.map
